import i18n from "I18n";
import { createAction } from 'utils';
import { inMiniProgram, requestMiniProgramLocation } from "utils/WeChatUtil"

function getLocationSuccess({ dispatch, data }) {
    dispatch(
        createAction('campaignDetail/verifyGPS')(data)
    );
}

function getLocationFailed({ dispatch }) {
    dispatch(createAction("navBars/updateState")(
        {
            toastShowing: {
                value: true,
                content: i18n.t("campaignDetail:invalidGPSLocation"),
            },
        }
    ))
}

function getGeo({ dispatch, data, geoTimeout }) {
    navigator.geolocation.getCurrentPosition(
        (position) => {
            getLocationSuccess({ dispatch, data: { ...data, latitude: position.coords.latitude, longitude: position.coords.longitude } })
        },
        (error) => {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                case error.POSITION_UNAVAILABLE:
                case error.TIMEOUT:
                default:
                    getLocationFailed({ dispatch })
            }
        },
        geoTimeout || {}
    );
}

export function requestLocation({ data, dispatch, geoTimeout = {} }) {
    const isInMiniProgram = inMiniProgram()
    if (isInMiniProgram) {
        requestMiniProgramLocation({
            onSuccess: (res) => {
                getLocationSuccess({ dispatch, data: { ...data, latitude: parseFloat(res.latitude), longitude: parseFloat(res.longitude) } })
            },
            onFailed: () => {
                getLocationFailed({ dispatch })
            },
            onCancel: () => {
                getLocationFailed({ dispatch })
            }
        })
        return
    }
    getGeo({
        dispatch,
        data,
        geoTimeout
    })
}